let sidebarOpen = true;
let sidebar = document.querySelector('.sidebar');
let toggleMapOptions = document.getElementById("toggleMapOptions");
let sortableMapList = document.getElementById("sortableMapList");
/*
function google_maps_lazyload() {
	'use strict'


	var options = {
		rootMargin: '100px',
		threshold: 0
	}

	var map = document.getElementById('map')

	var observer = new IntersectionObserver(
		function(entries, self) {
			// Intersecting with Edge workaround https://calendar.perfplanet.com/2017/progressive-image-loading-using-intersection-observer-and-sqip/#comment-102838
			var isIntersecting = typeof entries[0].isIntersecting === 'boolean' ? entries[0].isIntersecting : entries[0].intersectionRatio > 0
			if (isIntersecting) {
				var mapsJS = document.createElement('script')
				mapsJS.src = 'https://maps.googleapis.com/maps/api/js?v=3&key=AIzaSyBavo4z-WI2bHvv0d9FLjTV53QCCPUR_Tw&map_ids=790badb03a1b6e41&callback=fellowship.initMap&language=en';
				document.getElementsByTagName('head')[0].appendChild(mapsJS)
				self.unobserve(map)
			}
		},
		options
	)

	observer.observe(map)

}

google_maps_lazyload();*/

/**
 * Scroll to element with offset
 * @param string id
 * @param int offset
 */
const scrollIntoViewWithOffset = (id, offset) => {
	console.log('Scroll to '+id);
	window.scrollTo({
	  behavior: 'smooth',
	  top:
		document.getElementById(id).getBoundingClientRect().top -
		document.body.getBoundingClientRect().top -
		offset,
	})
}

fellowship.isMobile = function() {
	// device detection
	return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

}

fellowship.toggleMapOptions = function() {
	let toggleBtn = document.querySelector('.filter-toggle');
	let toggleHtml = toggleBtn.innerHTML;

	toggleBtn.innerHTML = toggleBtn.getAttribute('toggle');
	toggleBtn.setAttribute('toggle', toggleHtml);

	toggleBtn.classList.toggle("is-closed");
	sidebar.classList.toggle("is-closed")
	let mapPane = document.getElementById("mapPane");
	if(mapPane.classList.contains("is-closed")) {
		sidebarOpen = false;
		mapPane.classList.toggle("animate__slideOutLeft");
		mapPane.classList.toggle("animate__slideInLeft");
	} else {
		sidebarOpen = true;
		mapPane.classList.toggle("animate__slideOutLeft");
		mapPane.classList.toggle("animate__slideInLeft");
	}
}

let drawerHandles = document.getElementsByClassName('drawer-handles');
let drawers = document.getElementsByClassName('drawer');
let currentDrawer;

function toggleDrawer(element) {
	element.classList.toggle("animate__slideOutLeft");
	element.classList.toggle("animate__slideInLeft");
	element.classList.add("open-drawer");
}
function closeDrawer(element) {
	if(currentDrawer !== undefined) {
		element.classList.add("animate__slideOutLeft");
		element.classList.remove("animate__slideInLeft");
	}
}
for(let i=0; i < drawerHandles.length; i++) {
	drawerHandles[i].addEventListener("click", function(e) {
		let handle = drawerHandles[i].dataset.target;
		if(null === handle) {
			return;
		}

		for(let i=0; i < drawers.length; i++) {
			if(drawers[i].id === handle) {
				toggleDrawer(drawers[i]);
				currentDrawer = drawers[i];
			} else {
				closeDrawer(drawers[i]);
			}
		}
		e.preventDefault();
	},{passive:true});
}
let drawerClosers = document.getElementsByClassName("drawer-closer");
for(let i=0; i< drawerClosers.length; i++) {
	drawerClosers[i].addEventListener("click", function (e){
		closeDrawer(currentDrawer);
		e.preventDefault();
	},{passive:true});
}

/**
 * Map JS be found below
 * =====================================================================
 */

/**
 * Global variables
 */
let map, markers = [], circles = [], circle;

/**
 * Get JSON
 * TODO: Use fetch? Couldnt get to work with Babel
 *
 * @param url
 * @param callback
 */
let getJSON = function(url, callback) {

	let xhr = new XMLHttpRequest();
	xhr.open("GET", url, true);

	xhr.onreadystatechange = () => {
		if (xhr.status === 404) {
			// do something
		}
	};

	xhr.onload = function() {

		if (this.status !== 404) {

			let status = xhr.status;

			if (status === 200) {
				let res = JSON.parse(xhr.response);
				callback(null, res);

			}
		}

	};

	xhr.send();

};

fellowship.clusterer = undefined;
/**
 * Initialise map on successful callback from Google Maps Scripts
 */
fellowship.initMap = function() {

	let mapElement = document.getElementById("map");
	/**
	 * If Map element doesnt exist on the page
	 * no need to go on, get out of here!
	 */
	if(mapElement === null) {
		console.error('Map container not found.')
		return;

	}

	fellowship.bounds = 0;

	fellowship.visibleMarkers = [];

	/**
	 * Global settings
	 * @type {{iconBase: string, railRoadColor: string, showClusters: boolean}}
	 */
	fellowship.defaults = {
		"showClusters": true,
		"railRoadColor": "orange",
		"iconBase": "https://www.gwrr.com/wp-content/themes/gwrrusa_f21/assets/src/img/",
		"showNumberedLabels": false,
		"center": {lat: 39.828175, lng: -98.5795},
		"zoom": 5

	};

	fellowship.mapSettings = Object.assign(fellowship.defaults, fellowship.set);

	fellowship.checkServiceBox = function(name) {
		let checkbox = document.getElementById(name);
		if(checkbox !== null) {
			checkbox.checked = true;
			if(distanceInput !== null) {
				distanceInput.disabled = false;
			}
		} else {
			document.getElementById("searchLocationSubmit").disabled = false;
			document.getElementById("location").disabled = true;
			distanceInput.disabled = true;

			goTo = name;

		}

	}

	fellowship.services = function(name) {
		if(name !== "") {
			name = name.split(",");
			if(Array.isArray(name)) {

				name.map((service) => {
					fellowship.lastCheckedFilter = service;
					if(service === 'all') {
						let checkboxes = ['railroad', 'transload', 'industrial', 'ports'];
						checkboxes.forEach(function (service) {
							fellowship.checkServiceBox(service);
						});
					} else {
						fellowship.checkServiceBox(service);
					}
				});
			} else {
				fellowship.lastCheckedFilter = name;
				let checkbox = document.getElementById(name);
				if(checkbox !== null) {
					checkbox.checked = true;
				}
			}
		}
	}

	/**
	 * Center the map on USA
	 *
	 * @type {google.maps.LatLng}
	 */
	let us_center = new google.maps.LatLng(fellowship.mapSettings.center);
	console.info('Map settings', fellowship.mapSettings)
	/**
	 * Init Map
	 *
	 * @type {google.maps.Map}
	 */
	map = new google.maps.Map(mapElement, {

		center: us_center,
		zoom: fellowship.mapSettings.zoom,
		fullscreenControl: true,
		mapTypeControl: true,
		mapTypeControlOptions: {
			style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
			position: google.maps.ControlPosition.TOP_RIGHT,
		},
		mapId: '74074c453a9d5a57',
	});

	if(map === undefined) {

		return;

	}

	let infoBubble = new google.maps.InfoWindow({});

	if(fellowship.mapSettings.showClusters === true) {

		fellowship.clustererRailroads = new MarkerClusterer(map, [], {
			maxZoom: 8,
			imagePath: "/wp-content/themes/gwrrusa_f21/assets/dist/img/maps/clusterer/railroad/m",
			ignoreHidden: true
		});
		fellowship.clustererRailroads.setStyles(fellowship.clustererRailroads.getStyles().map(function (style) {
			style.textColor = '#fff';
			style.textSize = 16;
			style.fontWeight = 'bold';
			return style;
		}));
		fellowship.clustererTransload = new MarkerClusterer(map, [], {
			maxZoom: 8,
			imagePath: "/wp-content/themes/gwrrusa_f21/assets/dist/img/maps/clusterer/transload/m",
			ignoreHidden: true
		});
		fellowship.clustererTransload.setStyles(fellowship.clustererTransload.getStyles().map(function (style) {
			style.textSize = 16;
			style.fontWeight = 'bold';
			return style;
		}));
		fellowship.clustererIndustrial = new MarkerClusterer(map, [], {
			maxZoom: 8,
			imagePath: "/wp-content/themes/gwrrusa_f21/assets/dist/img/maps/clusterer/industrial/m",
			ignoreHidden: true,
		});
		fellowship.clustererIndustrial.setStyles(fellowship.clustererIndustrial.getStyles().map(function (style) {
			style.textSize = 16;
			style.fontWeight = 'bold';
			return style;
		}));

	}

	/**
	 * Offset for the sidebar
	 */
	map.panBy(-200, 0);

	let infowindow = new google.maps.InfoWindow({
		pixelOffset: new google.maps.Size(0, 50)
	});
	let geocoder = new google.maps.Geocoder();
	let searchLocationSubmit = document.getElementsByClassName("searchLocationSubmit");
	let clearLocationSearch = document.getElementById("clearLocationSearch");
	let locationInput = document.getElementsByClassName("location");
	let sidebarLocationInput = document.getElementById("do-location");
	let distanceInput = document.getElementById("distance");
	let sidebarDistanceInput = document.getElementById("doDistance");
	let distanceSelects=document.querySelectorAll("#doDistance,#distance");
	let isSearch = false;
	let goTo = false;
	let locationInputValue;
	let distanceInputValue;


	map.addListener("click", () => {
		closeDrawer(currentDrawer);
	});
	map.addListener("drag", () => {
		closeDrawer(currentDrawer);
	});

	/**
	 * FELLOWSHIP FUNCTIONS
	 * =====================================================================
	 */

	/**
	 * Remove results on map and reset to default
	 *
	 */
	fellowship.clearSearch = function() {
		isSearch = false;
		fellowship.removeCircle("radius");
		fellowship.setMapOnAll(null);
		if (map.getCenter() !== us_center) {
			map.setCenter(us_center);
			map.setZoom(5);
			map.panBy(-200, 0);
		}
	}

	fellowship.syncSelects = function() {

		// caching the changed element:
		let el = this;

		// retrieving the id of the element we should synchronise with
		// from the changed-element's data-syncwith custom attribute,
		// using document.getElementById() to retrieve that that element.
		let sync = document.getElementById( el.dataset.syncwith );
			// retrieving the <options of that element
			// and finding the <option> at the same index
			// as changed-element's selectedIndex (the index
			// of the selected <option> amongst the options
			// collection) and setting that <option> element's
			// selected property to true:
		if(sync !== null) {
			sync.options[el.selectedIndex].selected = true;
		}
	}

	fellowship.syncInputs = function() {

		// caching the changed element:
		let el = this;

		// retrieving the id of the element we should synchronise with
		// from the changed-element's data-syncwith custom attribute,
		// using document.getElementById() to retrieve that that element.
		let sync = document.getElementById( el.dataset.syncwith );
			// retrieving the <options of that element
			// and finding the <option> at the same index
			// as changed-element's selectedIndex (the index
			// of the selected <option> amongst the options
			// collection) and setting that <option> element's
			// selected property to true:
		if(sync !== null) {
			sync.value = el.value;
		}
	}

	fellowship.undisableSubmit = function(e) {
		locationInputValue = e.target.value;
		[].forEach.call(searchLocationSubmit, function (el) {
			el.disabled = e.target.value === '';
		});
	};

	/**
	 * Search on a user inputted location
	 * TODO: Add markers baed on service selection
	 */
	fellowship.search = function() {

		if(goTo !== false) {
			window.open("/" + goTo,"_self")
			return;
		}

		try {

			geocoder.geocode({address: locationInputValue}, (results, status) => {

				if (status === "OK") {

					let locationMarker = fellowship.addMarker("locationMarker", results[0].geometry.location, "location");
					let setDistance = (!isNaN(distanceInputValue)) ? distanceInputValue : 804650;

					isSearch = true;

					map.setCenter(results[0].geometry.location);

					const mq = window.matchMedia( "(max-width: 574px)" );
					console.log(mq);
					if (mq.matches) {
						console.log(mq);
						fellowship.toggleMapOptions();
					}


					fellowship.removeMarker("locationMarker");
					fellowship.removeCircle("radius");
					fellowship.addCircle("radius", locationMarker, setDistance);

					fellowship.bounds = circle.getBounds();

					fellowship.showVisibleMarkers(fellowship.bounds);

					if(sortableMapList !== null) {
						fellowship.showVisibleList();
					}

				} else {

					console.error("Geocode was not successful for the following reason: " + status);

				}

			});

		} catch(error) {
			console.error(error);
		}

	};

	/**
	 * Add railrods geojosn lines
	 * Accepts settings:
	 * 		railRoadColor
	 * Adds marker half way
	 * TODO: Does the half way marker need to be marked if RailRoad point is being shown? Are they the same location?
	 */
	//fellowship.railroads.forEach(function (railroad) {
	for(let i=0; i<fellowship.railroads.length; i++) {
		let railroad = fellowship.railroads[i];
		getJSON("/wp-content/themes/gwrrusa_f21/data/" + railroad + ".json", function (err, data) {

			try {

				const railroadName = railroad;

				data.features.map((railroad) => {

					let layer = new google.maps.Data({map: map});

					if (railroadName !== 'CGR') {
						layer.setStyle({
							strokeColor: fellowship.mapSettings.railRoadColor,
							strokeWeight: 2,
							strokeOpacity: 1
						});
					} else {
						let lineSymbol = {
							path: 'M 0,-1 0,1',
							strokeOpacity: 0.8,
							scale: 2
						};

						layer.setStyle({
							strokeColor: fellowship.mapSettings.railRoadColor,
							strokeWeight: 2,
							strokeOpacity: 0.2,
							icons: [{
								icon: lineSymbol,
								offset: '0',
								repeat: '15px'
							}],
						});
					}


					layer.addGeoJson(railroad);

					let bounds = new google.maps.LatLngBounds();

					/**
					 * Listen to clicks on the Railroad line.
					 */
					/*map.addListener("click", (mapsMouseEvent) => {
						console.info(JSON.stringify(mapsMouseEvent.latLng.toJSON(), null, 2));
					});*/
					google.maps.event.addListener(layer, "click", function (e) {

						try {

							let coordinates = e.feature.getGeometry().getArray();
							let halfWay = Math.round(coordinates.length / 2);
							let propertyName = e.name;

							for (let i = 0; i < coordinates.length; i++) {

								bounds.extend(coordinates[i]);

							}

							console.info(JSON.stringify(e.latLng.toJSON(), null, 2));

							fellowship.bounds = bounds

							map.fitBounds(fellowship.bounds);

							let markerData = {
								"name": railroadName,
								"location": bounds.getCenter().toJSON()
							}
							console.info(JSON.stringify(e.latLng.toJSON(), null, 2));
							console.info(markerData);

							let marker = fellowship.addMarker(markerData, markerData.location);
							marker.setVisible(true);

							isSearch = false;
							fellowship.removeCircle("radius");
							fellowship.setMapOnAll(map);
							fellowship.showVisibleMarkers(fellowship.bounds);

						} catch (boundsError) {

							console.error(railroadName + {boundsError});

						}

					});

				});

			} catch (err) {
				//console.error(err + ": " + railroad + " has no geoJson");

			}

		}, {

			passive: true

		});
	}
	//});

	fellowship.addCounties = function() {
		const layer = new google.maps.Data({map: map});

		let lineSymbol = {
			path: 'M 0,-1 0,1',
			strokeOpacity: 0.8,
			scale: 2
		};

		layer.setStyle({
			fill: 0,
			fillColor:'transparent',
			strokeColor: '#cccccc',
			strokeWeight: 1,
			strokeOpacity: 0.2,
			icons: [{
				icon: lineSymbol,
				offset: '0',
				repeat: '15px'
			}],
		});

		layer.addGeoJson(
			fellowship.counties
		);


	}

	fellowship.addRailRoadsFromFile = function(file, style) {

		getJSON(file, function (err, data) {

			try {

				for(let k in data ) {

					const layer = new google.maps.Data({map: map});

						layer.setStyle({
							strokeColor: fellowship.mapSettings.railRoadColor,
							strokeWeight: 2,
							strokeOpacity: 1
						});
						if(data.hasOwnProperty(k)) {
							layer.addGeoJson(data[k]);
						}
				}

			} catch(err) {

				console.error(err + ": " + railroad + " has no geoJson");

			}

		});

	};
	/**
	 * Grab a static satalite image from Google
	 * Place marker on center.
	 * @param marker
	 */
	fellowship.getSataliteImageForLocation = function(marker) {
		const iconBase = fellowship.mapSettings.iconBase;
		const url = window.location.origin + iconBase;
		return "https://maps.googleapis.com/maps/api/staticmap?center="+ marker.data.lat +","+ marker.data.lng +"&zoom=14&size=600x200&maptype=satellite&key=AIzaSyBavo4z-WI2bHvv0d9FLjTV53QCCPUR_Tw&language=en&markers=icon:"+ iconBase + marker.type + ".png|label:1|"+ marker.data.lat +","+ marker.data.lng;
	}

	fellowship.infoBubbleContents = function(marker) {

		let emailLink=``, phoneLink =``, contactBlock = ``, sataliteImage = ``, industrialContent = ``, transloadContent = ``, portsRailroads=``, railroadContent = ``;
		let moreInfo =  (marker.data.post_status === 'publish') ? `<a href="${marker.data.url.toLowerCase()}" class="iw-more-details">More information</a>` : '';
		if(marker.type === 'ports') {
			for (let key in marker.data.railroads) {
				if (marker.data.railroads.hasOwnProperty(key)) {
					portsRailroads = `<li><a href="${marker.data.railroads[key].url}">${marker.data.railroads[key].name}</a></li>`;
				}
			}
		}
		if(marker.type === "industrial" || marker.type === "transload") {
			if (marker.data.contact_email !== undefined && marker.data.contact_email !== '') {
				emailLink = `<a href="mailto:${marker.data.contact_email}" class="iw-email">${marker.data.contact_email}</a>`;
			}
			if (marker.data.contact_phone !== undefined  && marker.data.contact_phone !== '') {
				phoneLink = `<a href="tel:${marker.data.contact_phone}" class="iw-tel">T ${marker.data.contact_phone}</a>`;
			}
		}
		if(emailLink !== '' || phoneLink !== '') {
			contactBlock = `<div class="iw-contact">
									<h3>Contact</h3>
									<b class="mb-4">${marker.data.contact_name}</b>
									${emailLink}
									${phoneLink}
								</div>`;
		}
		if(marker.type === 'industrial') {
			sataliteImage = fellowship.getSataliteImageForLocation(marker);

			industrialContent = `	<div id="infoWindow" class="${marker.type}">
										<h3>${marker.title}</h3>
										<div class="flex">
											<div class="col-xs-12 col-sm-8 col-no-gutter">
												<dl>
													<dt>Total Acreage (size)</dt>
													<dd>${marker.data.size}</dd>
													<dt>Address</dt>
													<dd>${marker.data.address}, ${marker.data.city}, ${marker.data.state}, ${marker.data.zip}</dd>
													<dt>County</dt>
													<dd>${marker.data.county}</dd>
													<dt>Property Highlights</dt>
													<dd>${marker.data.highlights}</dd>
												</dl>
												${moreInfo}
											</div>
											<div class="col-xs-12 col-sm-4 first-xs last-sm col-no-r-gutter">
												${contactBlock}
											</div>
										</div>
										<img loading="lazy" src="${sataliteImage}" alt="Static satalite imagery of ${marker.title}" height="200" width="600" class="mt-4">
									</div>`.trim();
		}
		if(marker.type === 'transload') {
			transloadContent = `	<div id="infoWindow" class="${marker.type}">
										<h3>${marker.title}</h3>
										<div class="flex">
											<div class="col-xs-12 col-sm-8 col-no-gutter">
												<dl>
													<dt>Serving Railroad</dt>
													<dd>${marker.data.rr_name}<br>(${marker.data.railroad})</dd>
													<dt>Facility Type</dt>
													<dd>${marker.data.type}</dd>
													<dt>Class 1 Interchanges</dt>
													<dd>${marker.data.interchanges}</dd>
												</dl>
												${moreInfo}
											</div>
											<div class="col-xs-12 col-sm-4 first-xs last-sm col-no-r-gutter">
												${contactBlock}
											</div>
										</div>
										${sataliteImage}
									</div>`.trim();

		}

		if(marker.type === 'railroad') {
			if(marker.title === 'CGR' || marker.data.class_one === '' && marker.data.capacity === '' && marker.data.railcar_storage === '') {
				railroadContent = `	<div class="infobox-wrapper">
									<div id="infoWindow">
										<h3>${marker.data.name}</h3>
										<a href="/${marker.title.toLowerCase()}" class="iw-more-details" title="Learn more about ${marker.title}">Learn more about ${marker.title}</a>
									</div>
								</div>`.trim();
			} else {
				railroadContent = `	<div class="infobox-wrapper">
									<div id="infoWindow">
										<h3>${marker.data.name}</h3>
										<p><strong>Miles:</strong> ${marker.data.miles}</p>
										<p><strong>Class 1 Connections:</strong> ${marker.data.class_one}</p>
										<p><strong>Capacity:</strong> ${marker.data.capacity}</p>
										<p><strong>Railcar Storage Available:</strong> <a href="/${marker.title.toLowerCase()}/railcar-storage/" title="${marker.data.railcar_storage} spots">${marker.data.railcar_storage} spots</a></p>
										<a href="/${marker.title.toLowerCase()}/" class="iw-more-details" title="Learn more about ${marker.title}">Learn more about ${marker.title}</a>
									</div>
								</div>`.trim();
			}
		}


		const contents = {
			industrial: {
				content: industrialContent
			},
			railroad: {
				content: railroadContent
			},
			transload: {
				content: transloadContent
			},
			ports: {
				content: `	<div id="infoWindow">
								<h3>${marker.title}</h3>
								<div class="flex">
									<div class="col-xs-12 col-sm-8 col-no-gutter">
										<dl>
											<dt>Serving Railroads</dt>
											<dd><ul>${portsRailroads}</ul></dd>
											<dt>Class 1 Connections</dt>
											<dd>${marker.data.class_one} </dd>
											<dt>Channel Depth</dt>
											<dd>${marker.data.channel_depth} feet</dd>
											<dt>Deepwater Births</dt>
											<dd>${marker.data.deepwater_births} </dd>
											<dt>On-Dock Warehouse Space / Covered Storage</dt>
											<dd>${marker.data.warehouse_space + 'sq ft'}</dd>
											<dt>Total Current Acreage / Future Expansion Acreage</dt>
											<dd>${marker.data.current_expansion_acreage} </dd>
										</dl>
									</div>
								</div>
							</div>`.trim()
			}

		};

		return contents[marker.type].content;

	}

	/**
	 * Add Information Window to Marker
	 * Pass Marker ID and Contents of HTML type
	 * TODO: Optionally Zoom to Landmass
	 *
	 * @param marker
	 */
	fellowship.addInfoWindowToMarker = function(marker) {
		let bg = document.querySelector("#map > div > div > div:nth-child(2) > div:nth-child(2)");

		if(bg!== null) {
			bg.style.backgroundColor = 'rgba(0,0,0,0)';
		}
		infoBubble.close();
		infoBubble = new google.maps.InfoWindow({
			content: fellowship.infoBubbleContents(marker),
		});
		if(bg!== null) {
			bg.style.backgroundColor = 'rgba(0,0,0,0.5)';
			bg.style.opacity = 1;
		}
		infoBubble.open(map, marker);
		marker.setZIndex(1000);

		infoBubble.addListener("closeclick",function(){
			if(bg!== null) {
				bg.style.backgroundColor = 'rgba(0,0,0,0.0)';
			}
			marker.setZIndex(0);
		});

		document.addEventListener("keydown", function(e) {
			if(e.key === "Escape") {
				infoBubble.close();
				if(bg!== null) {
					bg.style.backgroundColor = 'rgba(0,0,0,0.0)';
				}
				marker.setZIndex(0);
			}
		});
	}
	fellowship.addMarkersFromObject = function(object, style) {
		for(let i=0; i<object.length; i++) {

			fellowship.addIndexToMarker(object[i], i);

			fellowship.addMarker(object[i], { lat: parseFloat(object[i].lat), lng: parseFloat(object[i].lng) }, style ? style : "railroad");
		}
	}
	/**
	 * Add markers from JSON file containing lat/lon points,
	 * Optionially pass a Marker Style (Default: (Library)
	 * TODO: Update default style
	 *
	 * @param file
	 * @param style
	 */
	fellowship.addMarkersFromFile = function(file, style) {

		getJSON(file, async function (err, data) {

			try {
				data.map((location, i) => {
				//for (let i = 0; i < data.length; i++) {
					fellowship.addIndexToMarker(data[i], i);
					//fellowship.addMarker(data[i], new google.maps.LatLng(data[i].lat, data[i].lng), style ? style : "railroad");
					fellowship.addMarker(data[i], { lat: parseFloat(data[i].lat), lng: parseFloat(data[i].lng) }, style ? style : "railroad");

				//}
				});

			} catch (err) {

				console.error({err});

			}

		});

	}

	fellowship.addIndexToMarker = function(location, index) {
		location.index = '';
		location.id = ++ index;
		if (fellowship.mapSettings.showNumberedLabels === true) {
			location.index = index.toString();
			return location;
		}

		return location;
	}

	/**
	 * Set some Marker styles
	 * @param name
	 * @returns {*}
	 */
	fellowship.iconStyle = function(name) {

		const iconBase = fellowship.mapSettings.iconBase;
		const icons = {
			railroad: {
				icon: {
					url: iconBase + "railroad.svg",
					scale: 1.2,

				}
			},
			industrial: {
				icon: {
					url: iconBase + "industrial.svg",
					scale: 0.5,
					/*size: new google.maps.Size(24, 24),
					anchor: new google.maps.Point(12, 12),
					scaledSize: new google.maps.Size(24,24),*/
				},
			},
			transload: {
				icon: {
					url: iconBase + "transload.svg",
					scale: 0.5,
					/*size: new google.maps.Size(28, 28),
					anchor: new google.maps.Point(10, 10),
					labelOrigin: new google.maps.Point(15, 20),
					scaledSize: new google.maps.Size(28,28),*/
				}
			},
			ports: {
				icon: {
					url: iconBase + "ports.svg",
					scale: 0.5,
					/*size: new google.maps.Size(24, 24),
					anchor: new google.maps.Point(12, 12),
					scaledSize: new google.maps.Size(24,24),*/
				}
			},
			location: {
				icon: {
					/**
					 * Need to keep this here to prevent errors
					 */
				}
			}
		};

		return icons[name].icon;

	}

	fellowship.labelStyle = function(data, name) {
		const labels = {

			railroad: {
				text: data.code,
				color: "white",
				fontSize: "12px",
			},
			transload: {
				text: (data.index) ? data.index : " ",
				fontSize: "10px",
			},
			industrial: {
				text: (data.index) ? data.index : " ",
				fontSize: "10px",
			}

		}

		return labels[name];
	}
	/**
	 * Add marker passing name and position and optional style name
	 *
	 * @param data
	 * @param position
	 * @param style
	 * @returns {google.maps.Marker}
	 */
	fellowship.addMarker = function(data, position, style = "location") {
		const markerData = {
			location: {
				options: {
					id: "location-" + data.code,
					position: position,
					visible: false,
					icon: null
				}
			},
			railroad: {
				options: {
					id: "railroad-" + data.code,
					map: map,
					position: position,
					title: data.code,
					type: style,
					icon: fellowship.iconStyle(style),
					label: fellowship.labelStyle(data, style),
					data: data,
					visible: false,
					optimized: true,
				}
			},
			industrial: {
				options: {
					id: "industrial-" + data.id,
					map: map,
					position: position,
					title: data.name,
					type: style,
					icon: fellowship.iconStyle(style),
					label: fellowship.labelStyle(data, style),
					data: data,
					visible: false,
					optimized: true,
				}
			},
			transload: {
				options: {
					id: "transload-" + data.id,
					map: map,
					position: position,
					title: data.name,
					type: style,
					icon: fellowship.iconStyle(style),
					label: fellowship.labelStyle(data, style),
					data: data,
					visible: false,
					optimized: true,
				}
			},
			ports: {
				options: {
					id: "port-" + data.post_id,
					map: map,
					position: position,
					title: data.name,
					type: style,
					icon: fellowship.iconStyle(style),
					label: fellowship.labelStyle(data, style),
					data: data,
					visible: false,
					optimized: true,
				}
			}
		}

		const marker = new google.maps.Marker(

			markerData[style].options

		);

		marker.addListener("click", () => {

			fellowship.addInfoWindowToMarker(marker, location.name);
			fellowship.scrollToListItem(marker);
			map.setCenter(marker.getPosition());
			/**
			 * if sidebar open pan window
			 */
			if(sidebarOpen === true) {
				map.panBy(-200, 0);
			}

		}, {passive: true});

		markers.push(marker);

		return marker;

	}

	/**
	 * Add a circle overlay to searched area
	 *
	 * @param name
	 * @param marker
	 * @param distance - default is 500 miles in metres
	 */
	fellowship.addCircle = function(name, marker, distance = 804650) {

		circle = new google.maps.Circle({

			map: map,
			radius: parseFloat(distance),
			fillColor: '#f18701',
			strokeColor: '#f18701',
			strokeWeight: 1,

		});

		circles[name] = circle
		circle.bindTo("center", marker, "position");

		map.fitBounds(circle.getBounds());

	}

	/**
	 * Remove a marker by name
	 *
	 * @param name
	 */
	fellowship.removeMarker = function(name) {

		if (markers[name]) {

			infowindow.close();
			markers[name].setMap(null);
			delete markers[name];

		}

	}

	/**
	 * Remove a circle by name
	 *
	 * @param name
	 */
	fellowship.removeCircle = function(name) {

		if (circles[name]) {

			circles[name].setMap(null);
			delete circles[name];

		}

	}

	/**
	 * Show visible markers within set bounds
	 * ✔
	 * TODO: Only show filtered markers at a time
	 *
	 * @param bounds
	 */
	fellowship.showVisibleMarkers = function(bounds) {

		if(bounds === 0) {
			return;
		}

		let labelIndex = 1;
		fellowship.visibleLocationList = [];

		//markers.map((marker) => {
		for(let i=0; i<markers.length; i++){
			let marker = markers[i];
			if(fellowship.filter(marker.type)) {

				if (bounds.contains(marker.getPosition()) === true) {
					marker.setVisible(true);
					if (fellowship.mapSettings.showClusters === true) {
						if (marker.type === 'railroad') {
							fellowship.clustererRailroads.addMarker(marker, true)
						}
						if (marker.type === 'industrial') {
							fellowship.clustererIndustrial.addMarker(marker, true)
						}
						if (marker.type === 'transload') {
							fellowship.clustererTransload.addMarker(marker, true)
						}
					}

					labelIndex++;
					// TODO: REMEMBER TO OFFSET LIST TO 1, MARKERS ARE ALREADY SET TO START FROM 1 not 0
					fellowship.visibleLocationList.push(marker.id);

				} else {

					marker.setVisible(false);
					if (fellowship.mapSettings.showClusters === true) {
						if (marker.type === 'railroad') {
							fellowship.clustererRailroads.removeMarker(marker, true)
						}
						if (marker.type === 'industrial') {
							fellowship.clustererIndustrial.removeMarker(marker, true)
						}
						if (marker.type === 'transload') {
							fellowship.clustererTransload.removeMarker(marker, true)
						}
					}
				}

			} else {

				marker.setVisible(false);
				if (fellowship.mapSettings.showClusters === true) {
					if (marker.type === 'railroad') {
						fellowship.clustererRailroads.removeMarker(marker, true)
					}
					if (marker.type === 'industrial') {
						fellowship.clustererIndustrial.removeMarker(marker, true)
					}
					if (marker.type === 'transload') {
						fellowship.clustererTransload.removeMarker(marker, true)
					}
				}

			}

		}//);

		/**
		 * Dont run these in the for loop - takes too much resources
		 */

		if (fellowship.mapSettings.showClusters === true) {
			fellowship.clustererRailroads.repaint();
			fellowship.clustererIndustrial.repaint();
			fellowship.clustererTransload.repaint();
		}

		//fellowship.setMapOnAll(map);

	}

	fellowship.showVisibleList = function() {
		const visibleMarkers = fellowship.visibleLocationList;
		let x = document.querySelectorAll('.map-list-item');
		for (let i = 0; i < x.length; i++) {
			x[i].style.display = "none"
		}
		visibleMarkers.map((marker) => {
			document.querySelector("[data-railroad='"+marker+"']").style.display = "table";
		});
	}

	fellowship.visibleLocationList = [];

	fellowship.filter = function(type) {
		let filters = fellowship.getFilterChecks("filter");
		return filters.includes(type);
	}

	/**
	 * Open the info window for the given marker
	 * @param marker
	 */
	fellowship.openInfoWindow = function(marker) {
		infoBubble.open(map, marker);
	}

	/**
	 * Show all visible markers on map
	 * @param map
	 */
	fellowship.setMapOnAll = function(map) {

		markers.map((marker) => {

			marker.setMap(map);

		});

	}

	/**
	 * Get Filter checkbox values
	 * @param name
	 * @returns {*[]}
	 */
	fellowship.getFilterChecks = function (name) {

		let checkboxes = document.getElementsByName(name);
		return Array.prototype.slice.call(checkboxes).filter(ch => ch.checked === true).map(a => a.id)

	}

	/**
	 * TODO: Do something with checked boxes ✔
	 * @type {NodeListOf<HTMLElement>}
	 */
	let checkboxes = document.getElementsByName("filter");

	for (let i = 0; i < checkboxes.length; i++) {

		checkboxes[i].addEventListener("change", function(e) {

			fellowship.lastCheckedFilter = this.id;

			fellowship.showVisibleMarkers(fellowship.bounds);
			if(fellowship.isMobile()) {
				fellowship.toggleMapOptions();
			}
			if(sortableMapList !== null) {
				fellowship.showVisibleList();
			}

		});

	}

	let servicesSelect = document.getElementById("select-service");

	if(servicesSelect !== null) {
		servicesSelect.addEventListener("change", function(e) {

			fellowship.resetFilters();

			fellowship.lastCheckedFilter = this.value;

			fellowship.services(fellowship.lastCheckedFilter);
			if(fellowship.isMobile()) {
				fellowship.toggleMapOptions();
			}
		});
	}

	fellowship.resetFilters = function() {
		let checkboxes = document.getElementsByName("filter");

		for (let i = 0; i < checkboxes.length; i++) {
			checkboxes[i].checked = false;
		}
	}

	let micrositeFilterMenu = document.querySelectorAll('.filter-service');

	if(micrositeFilterMenu !== null) {
		for(let i = 0; i < micrositeFilterMenu.length; i++) {
			micrositeFilterMenu[i].addEventListener('click', function (e) {
				e.preventDefault();

				fellowship.resetFilters();

				fellowship.lastCheckedFilter = this.childNodes[0].href.split('#')[1];

				//let elmnt = document.getElementById("map");
				scrollIntoViewWithOffset('map', 150);
				//elmnt.scrollIntoView();

				fellowship.services(fellowship.lastCheckedFilter);
				if(fellowship.isMobile()) {
					fellowship.toggleMapOptions();
				}
			});
		}
	}


	/**
	 * Not sure why I added this, could be useful
	 * gets set in change event on checkbox (above)
	 * @type {null}
	 */
	fellowship.lastCheckedFilter = null;

	fellowship.addMarkersFromCallback = function(url) {
		let script = document.createElement('script');
		script.src = url;
		document.getElementsByTagName('head')[0].appendChild(script);
	}

	fellowship.eqfeed_callback = function (results) {
		let style = "industrial";
		for (let i = 0; i < results.length; i++) {
			const location = results[i];
			fellowship.addIndexToMarker(location, i);

			fellowship.addMarker(location, { lat: parseFloat(location.lat), lng: parseFloat(location.lng) }, style?style:"railroad");
		}
	};

	/**
	 * EVENT LISTENERS
	 * =====================================================================
	 */

	/**
	 * TODO: I think this disables the search until all inputs are filled...
	 */
	for (let i = 0; i < locationInput.length; i++) {
		locationInput[i].addEventListener("input", fellowship.undisableSubmit);
		locationInput[i].addEventListener("input", fellowship.syncInputs);
	}

	for (let i = 0; i < distanceSelects.length; i++) {
		distanceSelects[i].addEventListener("change", fellowship.syncSelects);
		distanceSelects[i].addEventListener("change", function() {
			distanceInputValue = distanceSelects[i].value;
			[].forEach.call(locationInput, function (el) {
				el.disabled = false;
			});

		});
	}

	for (let i = 0; i < searchLocationSubmit.length; i++) {
		searchLocationSubmit[i].addEventListener("click", fellowship.search);
	}

	if(sidebarLocationInput !== null) {
		sidebarLocationInput.addEventListener('search', function (e) {
			if (e.type === 'search') {
				if (e.currentTarget.value === "") {
					fellowship.clearSearch();
				}
			}
		});
	}

	fellowship.accordion = function(id) {
		let x = document.getElementById(id);
		if (x.className.indexOf("sidebar-accordion-show") === -1) {
			x.className += " sidebar-accordion-show";
		} else {
			x.className = x.className.replace(" sidebar-accordion-show", "");
		}
	}

	fellowship.goToMarker = function(e) {

		markers.map((marker) => {
			if (marker.id === e.getAttribute("data-railroad")) {
				map.setZoom(9);
				map.setCenter(marker.getPosition());
				map.panBy(-200,0);
				fellowship.addInfoWindowToMarker(marker);
				if(fellowship.isMobile()) {
					fellowship.toggleMapOptions();
				}
			}
		});
		return false;
	}

	fellowship.scrollToListItem = function(marker) {
		let accordionLinks = document.getElementsByClassName("sidebar-accordion-link");
		if(accordionLinks.length !== 0) {
			let myElement = document.getElementById("list-" + marker.id);
			myElement.querySelector("a").focus();
			fellowship.scrollUL(myElement);
			//document.document.querySelectorAll('.sidebar-accordion-show .list-unstyled').scrollTop = myElement.offsetTop;
			return true;
		}
		return false;
	}

	fellowship.scrollUL = function(li) {
		// scroll UL to make li visible
		// li can be the li element or its id
		if (typeof li !== "object"){
			li = document.getElementById(li);
		}
		let ul = li.parentNode;
		// fudge adjustment for borders effect on offsetHeight
		let fudge = 4;
		// bottom most position needed for viewing
		let bottom = (ul.scrollTop + (ul.offsetHeight - fudge) - li.offsetHeight);
		// top most position needed for viewing
		let top = ul.scrollTop + fudge;
		if (li.offsetTop <= top){
			// move to top position if LI above it
			// use algebra to subtract fudge from both sides to solve for ul.scrollTop
			ul.scrollTop = li.offsetTop - fudge;
		} else if (li.offsetTop >= bottom) {
			// move to bottom position if LI below it
			// use algebra to subtract ((ul.offsetHeight - fudge) - li.offsetHeight) from both sides to solve for ul.scrollTop
			ul.scrollTop = li.offsetTop - ((ul.offsetHeight - fudge) - li.offsetHeight) ;
		}
	};

	if(sortableMapList !== null) {
		createTable(".sortableMapList", null, "sortable");
	}
	// clearLocationSearch.addEventListener('click', fellowship.clearSearch); NOT NEEDED
	/**
	 * GMAPS LISTENERS
	 * =====================================================================
	 */
	map.addListener('tilesloaded', function () {
		fellowship.loaded = true;
		fellowship.bounds = this.getBounds();
		fellowship.showVisibleMarkers(fellowship.bounds);
	});
	window.onload = function() {
		fellowship.showVisibleMarkers(fellowship.bounds);
	}
	/**
	 * Only show markers when at a particular zoom level
	 * Optionally cluster results - relies on global settings
	 */
	map.addListener("idle", function() {

		if(fellowship.loaded !== true) {
			return false;
		}

		fellowship.bounds = this.getBounds();

		if(isSearch === true) {
			return;
		}

		if(map.getZoom() >= 4) {

			fellowship.showVisibleMarkers(fellowship.bounds);

		}
		if(map.getZoom() >= 8 && fellowship.mapSettings.showClusters === true) {

			fellowship.clustererRailroads.repaint();
			fellowship.clustererIndustrial.repaint();
			fellowship.clustererTransload.repaint();

		}
		if(sortableMapList !== null) {
			fellowship.showVisibleList();
		}

	});
}
fellowship.compare = function(elem){
	var sid = elem.target.value;
	// add id to compids
	if(elem.target.checked === true){
		if(fellowship.compids.length <= 5){
			fellowship.compids.push(sid);
		} else {
			console.log('Limit reached');
			alert('You can compare up to 6 sites');
			elem.target.checked = false;
		}
	}
	else { //remove
		if(fellowship.compids.indexOf(sid) > -1){
			fellowship.compids.splice(fellowship.compids.indexOf(sid), 1);
		}
	}
	// re-save compids
	fellowship.basil.set('compids', fellowship.compids, { 'storage': 'local' });
	// show selected in target display element
	fellowship.displayStorage(fellowship.compids, fellowship.comp_display);
}

fellowship.displayStorage = function(compids, comp_display){
	var lihtml = '';
	var params = '';
	var cidlength = 6 - compids.length;
	if(compids.length > 0){
		comp_display.closest('aside').addClass('active').removeClass('hide-tab');
		comp_display.fadeIn(400);
		compids.forEach(function(el, idx){
			var val = compids[idx];
			let checkbox = jQuery('input[value="'+val+'"]');
			var name = checkbox.data('title');
			var url = checkbox.data('url');
			lihtml += '<li><a href="#" class="remove" data-remove="'+val+'" title="Remove from comparison"></a><a href="'+url+'" target="_blank">'+name+'</a></li>';
			params += val+',';
			// recheck checkbox
			console.log(checkbox.length)
			checkbox.prop('checked', true);
		});
		for (let i = 0; i < cidlength; i++) {
			lihtml += '<li></li>';
		}
		params = params.slice(0,-1);
		comp_display.html(lihtml);
		comp_display.closest('aside').fadeIn(400);
		// add button with link + params
		jQuery('#compare-footer .btn').remove();
		jQuery('.compare-footer-right').prepend('<a class="btn btn-orange" href="'+comp_url+params+'">Compare</a>');
	}
	else{
		comp_display.innerHTML = '';
		comp_display.fadeOut(400);
		jQuery('.compare-footer-right .btn').fadeOut(400);
		comp_display.closest('aside').removeClass('active').addClass('hide-tab');
	}
}

fellowship.displayStorage = function (compids, comp_display){
	var lihtml = '';
	var params = '';
	var cidlength = 6 - compids.length;
	if(compids.length > 0){
		comp_display.closest('aside').addClass('active').removeClass('hide-tab');
		comp_display.fadeIn(400);
		compids.forEach(function(el, idx){
			var val = compids[idx];
			var name = jQuery('input[value="'+val+'"]').data('title');
			var url = jQuery('input[value="'+val+'"]').data('url');
			lihtml += '<li><a href="#" class="remove" data-remove="'+val+'" title="Remove from comparison"></a><a href="'+url+'" target="_blank">'+name+'</a></li>';
			params += val+',';
			// recheck checkbox
			jQuery('input.id-comp[value='+val+']').prop('checked', true);
		});
		for (let i = 0; i < cidlength; i++) {
			lihtml += '<li></li>';
		}
		params = params.slice(0,-1);
		comp_display.html(lihtml);
		comp_display.closest('aside').fadeIn(400);
		// add button with link + params
		jQuery('#compare-footer .btn').remove();
		jQuery('.compare-footer-right').prepend('<a class="btn btn-orange" href="'+comp_url+params+'">Compare</a>');
	}
	else{
		comp_display.innerHTML = '';
		comp_display.fadeOut(400);
		jQuery('.compare-footer-right .btn').fadeOut(400);
		comp_display.closest('aside').removeClass('active').addClass('hide-tab');
	}
}

if(toggleMapOptions !== null) {
	toggleMapOptions.addEventListener("click", fellowship.toggleMapOptions);
}
